import { clsx } from 'clsx';
import { formatDateShort } from '@/date-utils/format-date.ts';
import {
  streamDescription,
  subscriptionInfo,
} from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';

export const SubscriptionExpiryNotice = ({
  cancelAt,
}: {
  cancelAt: string;
}) => {
  return (
    <div className={clsx(streamDescription, subscriptionInfo)}>
      Subscription expires on {formatDateShort(new Date(cancelAt))}
      <br />
      You can resubscribe after expiration date
    </div>
  );
};
